import React, { useState, ChangeEvent, FocusEvent } from 'react';

interface FormattedInputStructuredMessageProps {
  className?: string;
  disabled?: boolean;
  value?: string;
  onChange?: (value: string) => void;
  onBlur?: (event: FocusEvent<HTMLInputElement>) => void;
}

const FormattedInputStructuredMessage: React.FC<FormattedInputStructuredMessageProps> = ({
  className,
  disabled,
  value: initialValue = '',
  onChange,
  onBlur,
}) => {
  const [value, setValue] = useState(initialValue);

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const inputValue = event.target.value.replace(/\D/g, ''); // Remove non-digit characters
    let formattedValue = '';

    if (inputValue.length > 0) {
      formattedValue += inputValue.substr(0, 3);
      if (inputValue.length > 3) {
        formattedValue += '/' + inputValue.substr(3, 4);
      }
      if (inputValue.length > 7) {
        formattedValue += '/' + inputValue.substr(7, 5);
      }
    }

    setValue(formattedValue);
    if (onChange) {
      onChange(formattedValue);
    }
  };

  return (
    <input
      type="text"
      className={className}
      placeholder="000/0000/00000"
      value={value}
      onChange={handleChange}
      onBlur={onBlur}
      disabled={disabled}
    />
  );
};

export default FormattedInputStructuredMessage;
